var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4906 0.127125C9.99814 0.043455 9.49954 0.000933175 9 0C4.0275 0 0 4.0275 0 9C0 10.9091 0.600187 12.6731 1.60875 14.1362C2.2275 13.2272 3.65456 12.6 5.30888 12.6C6.44512 12.6 7.47281 12.8998 8.20912 13.3819L10.4906 0.127125ZM15.273 2.55431C16.8272 5.99119 15.4637 7.82719 15.4637 7.82719C14.409 4.65469 11.3546 4.19119 11.3546 4.19119C11.3546 4.19119 9.34538 15.0182 9.34538 15.1543C9.34538 16.3271 8.1 17.3182 6.40912 17.6181C7.24953 17.8709 8.12238 17.9996 9 18C13.9725 18 18 13.9725 18 9C18 6.47269 16.9543 4.19062 15.273 2.55431Z",
    fill: "#FBBF02"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.f3c72149123ad51e91c6b68ccc63645c.svg";
export { ForwardRef as ReactComponent };